'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValuesEnhanced = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _dateFns = require('date-fns');
var _dateFns2 = _interopRequireDefault(_dateFns);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
var _sdmxData = require('./sdmx-data');
var _date = require('./date');
var _refineTimePeriod = require('../../rules2/src/refineTimePeriod');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isNonCoded = R.both(R.has('value'), R.pipe(R.has('id'), R.not));
var getId = function getId(value, fallbackId) {
  var valueId = R.prop('id', value);
  if (valueId) return valueId;
  if (isNonCoded(value)) return R.prop('value', value);
  // Fallback (value has no id but is not a non-coded)
  return fallbackId;
};
var getName = function getName(_ref) {
  var isTimeDimension = _ref.isTimeDimension,
    options = _ref.options,
    locale = _ref.locale,
    start = _ref.start,
    reportYearStart = _ref.reportYearStart;
  return function (value) {
    if (!isTimeDimension) return R.prop('name')(value);
    return (0, _date.getReportedTimePeriodLabel)(options.frequency, options.timeFormat, locale)(reportYearStart, {
      id: value.id,
      reportedStart: start,
      start: new Date(value.start)
    });
  };
};
var getValuesEnhanced = exports.getValuesEnhanced = function getValuesEnhanced(_ref2) {
  var _ref2$locale = _ref2.locale,
    locale = _ref2$locale === undefined ? '' : _ref2$locale,
    _ref2$annotations = _ref2.annotations,
    annotations = _ref2$annotations === undefined ? [] : _ref2$annotations,
    _ref2$isTimeDimension = _ref2.isTimeDimension,
    isTimeDimension = _ref2$isTimeDimension === undefined ? false : _ref2$isTimeDimension,
    _ref2$parent = _ref2.parent,
    parent = _ref2$parent === undefined ? '' : _ref2$parent,
    reportYearStart = _ref2.reportYearStart,
    _ref2$hiddenIds = _ref2.hiddenIds,
    hiddenIds = _ref2$hiddenIds === undefined ? {} : _ref2$hiddenIds,
    _ref2$options = _ref2.options,
    options = _ref2$options === undefined ? {} : _ref2$options;
  return R.pipe(R.addIndex(R.map)(function (value, __index) {
    var id = getId(value, parent + '-' + __index);
    var valueAnnotations = R.pipe(R.propOr([], 'annotations'), R.flip(R.props)(annotations))(value);
    var isHidden = R.has(parent + '.' + id, hiddenIds) || (0, _sdmxData.getIsHidden)(valueAnnotations);
    var _ref3 = isTimeDimension ? getTimePeriodAttributes({
        reportYearStart: reportYearStart,
        options: options
      })(value) : {
        notes: []
      },
      start = _ref3.start,
      notes = _ref3.notes;
    var __indexPosition = NaN;
    if (isNaN(__indexPosition)) {
      __indexPosition = (0, _dotstatsuiteSdmxjs.getCodeOrder)({
        annotations: valueAnnotations
      });
    }
    var res = (0, _extends3.default)({}, R.omit(['names', 'value'], value), {
      id: id,
      display: !isHidden,
      start: start ? start.toISOString() : null,
      flags: notes,
      __indexPosition: __indexPosition,
      __index: __index,
      isNonCoded: isNonCoded(value)
    });
    if (!isNonCoded(value)) {
      res = R.assoc('name', getName({
        isTimeDimension: isTimeDimension,
        options: options,
        locale: locale,
        start: start,
        reportYearStart: reportYearStart
      })(value), res);
    }
    if (isTimeDimension) {
      res = (0, _refineTimePeriod.refineTimePeriod)(res, {
        locale: locale,
        monthlyFormat: options.timeFormat
      });
    }
    return res;
  }),
  // __indexPosition is used for pre-sorting
  R.sortWith(isTimeDimension ? timeDimensionSorts : defaultSorts),
  // __indexPosition is reset after pre-sorting
  R.addIndex(R.map)(function (val, index) {
    return R.assoc('__indexPosition', index, val);
  }),
  // values are re-sorted by __index after __indexPosition settlement
  R.sortBy(R.prop('__index')));
};
var getDateForSort = function getDateForSort(key) {
  return function (val) {
    return _dateFns2.default.getTime(new Date(R.prop(key, val)));
  };
};
var byStartDate = R.ascend(getDateForSort('start'));
var byEndDate = R.descend(getDateForSort('end'));
var timeDimensionSorts = [byStartDate, byEndDate];
var byIndexPosition = R.ascend(R.prop('__indexPosition'));
var byOrder = R.ascend(R.propOr(-1, 'order'));
var defaultSorts = [byIndexPosition, byOrder];
var getTimePeriodAttributes = function getTimePeriodAttributes(_ref4) {
  var reportYearStart = _ref4.reportYearStart,
    options = _ref4.options;
  return function (value) {
    var reported = (0, _date.getReportedTimePeriod)(reportYearStart, value, options.frequency);
    var start = reported.start;
    var end = reported.end;
    var reportTimeNote = (0, _date.getReportedTimePeriodNote)(reportYearStart, start, end, options.frequency, options.isRtl);
    var notes = R.isNil(reportTimeNote) ? [] : R.append(reportTimeNote, []);
    return {
      start: start,
      notes: notes
    };
  };
};